module.exports = __webpack_public_path__ + "static/img/2-50w.d612a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/two/2-50w.png
// module id = i7J1
// module chunks = 1